import { createContext } from "react";

export const AllowedModuleContex = createContext("")

